import ExternalLink from '../single/externalLink';

const Operable = () => {
	return (
		<>
		<h2 id="operable">Principio 2. <ExternalLink href="https://www.w3.org/TR/WCAG21/#operable" contents="Manejable" /></h2>
		<blockquote>
		<p>Los componentes de interfaz de usuario y la navegación deben ser manejables.</p>
		</blockquote>
		</>
	)
}

export default Operable;
